import { render, staticRenderFns } from "./DirectMessages.vue?vue&type=template&id=3429dc98"
import script from "./DirectMessages.vue?vue&type=script&lang=js"
export * from "./DirectMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports